import React from "react";
import Moment from "moment";
import { Typography } from "antd";
import { DATE_FORMAT, DATETIME_FORMAT } from "../../core/utils/i18n-js";
import { nowWithTimezone } from "../../core/utils/timezones";

const { Text } = Typography;

/* props
    value: date
    isDeadlineActive: bool
    formatDate: bool
    formatDateTime: bool
    format: string
*/

const DateTime = (props) => {
    const value = props.value;
    let format;
    if (props.formatDate) {
        format = DATE_FORMAT;
    } else if (props.formatDateTime) {
        format = DATETIME_FORMAT;
    } else {
        format = props.format ? props.format : DATETIME_FORMAT;
    }

    const isDeadlineActive = props.isDeadlineActive ? true : false;

    let textType = "";
    const now = nowWithTimezone();

    if (isDeadlineActive) {
        const diff = now.diff(value, "days");
        //        alert(diff + " " + value );
        /* menos de un dia */
        if (diff >= 0) {
            textType = "danger";
        } else if (diff >= -2 && diff < 0) {
            textType = "warning";
        }
    }

    if (value) {
        return <Text type={textType}>{Moment(value).format(format)}</Text>;
    } else {
        return <></>;
    }
};

export default DateTime;
